package com.ustadmobile.core.view

interface HolidayCalendarDetailView: UstadView {

    companion object {

        const val VIEW_NAME = "HolidayCalendarDetail"
    }

}